/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Activate_SuccessInputs */

const vi_user_activate_success = /** @type {(inputs: User_Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kích hoạt`)
};

/**

* @param {User_Activate_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_activate_success = /** @type {((inputs?: User_Activate_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Activate_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_activate_success(inputs)
});